import { defineComponent as _defineComponent } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'toast',
  props: {
  message: {
    type: String,
    default: '',
  }
},
  setup(__props) {



return { __sfc: true, }
}

})